<template>

  <v-container fluid>

    <v-layout>

      <v-flex xs6 class="mr-2">

        <v-card outlined>

          <v-tabs v-model="tab">
            <v-tab>Select Communities</v-tab>
            <v-tab>Service By Address</v-tab>
          </v-tabs>

          <v-card-text>
            <v-tabs-items v-model="tab">

              <v-tab-item>

                <v-autocomplete
                  v-model="locationsSelected"
                  style="z-index: 9900 !important;"
                  label="Selected locations"
                  :items="locationsFiltered"
                  return-object
                  single-line
                  multiple
                  autofocus
                  clearable
                  dense
                  v-ripple="false"
                  :ripple="false"
                  :menu-props="{ripple: false,}"
                  small-chips
                  deletable-chips
                  hint="Select one or more locations"
                  persistent-hint
                ></v-autocomplete>

              </v-tab-item>

              <v-tab-item>
                <AddressSearch is-flat @address-selected="handleAddressSelected">
                </AddressSearch>
              </v-tab-item>

            </v-tabs-items>

            <v-alert v-if="$store.getters.coordinatesFormatted" type="success" border="top"
                     class="mt-3 text-justify">
              <p>
                In addition to any communities selected, the point on the map will also be used to
                ensure we includes service(s) at that exact point.
              </p>

              <v-sheet label class="" color="grey lighten-3 black--text pa-1"
                       close
                       @click:close="clearCoordinates">
                Coordinates:
                ({{$store.getters.coordinatesFormatted}})
              </v-sheet>

              <!--              <v-btn x-small depressed @click="$store.dispatch('clearPreferencesByKey', 'coordinates')">-->
              <!--                Clear Coordinates-->
              <!--              </v-btn>-->

            </v-alert>

            <div v-else class="mt-5 primary--text">
              <v-icon color="secondary">mdi-clipboard-alert-outline</v-icon>
              Click on the map to add service results based on geographic coordinates.
            </div>

          </v-card-text>

        </v-card>

      </v-flex>

      <v-flex xs6 class="red">

        <StandardMap ref="mapComponent"
                     id="wizard-location-standard-map"
                     :min-height="480"
                     :loading="loading"
                     :disable-basemap-stack="true"
                     :show-identify-card="false"
                     :use-identify="false"
                     :include-service-areas-layer="false"
                     @map-ready="handleMapLoad"
                     @locationfound="handleLocationFound"
                     @identify-results="handleIdentifyResults"
        >

          <l-tile-layer
            url="http://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"></l-tile-layer>

        </StandardMap>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script>
import { Popup } from 'leaflet';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import intersection from 'lodash/intersection';

import StandardMap from '../map-components/StandardMap';
import AddressSearch from '@/components/AddressSearch';

export default {

  name: 'Wizard.Locations',

  components: { StandardMap, AddressSearch },

  props: [
    'items',
    'step',
  ],

  data() {
    return {
      loading: false,
      tab: 0,
      dialogConfirm: false,
      contextMenuOpen: false,
      showMessage: false,
      latlng: null,
      boundaries: null,
      labelGroup: null,
      flagRegionalMessage: false,
      popup: null,
    };
  },

  mounted() {
    setTimeout(() => {
      if (this.$refs.mapComponent) {
        this.$refs.mapComponent.invalidateSize();
      }
    }, 3000);
  },

  computed: {

    coordinates() {
      return this.$store.state.wizard.preferences.coordinates;
    },

    identifyPoint() {
      return this.$store.state.mapping.identifyPoint;
    },

    locations() {
      return this.$store.getters.allLocations;
    },

    locationsFiltered() {
      return this.$store.getters.locationsFiltered;
    },

    locationsSelected: {
      get() {
        return this.$store.state.wizard.preferences.locations;
      },
      set(selected) {
        console.log(selected);
        this.$store.dispatch('setPreferences', {
          ...this.$store.state.wizard.preferences,
          locations: uniqBy(selected, 'text'),
        });
      },
    },

    county() {
      return this.$store.state.wizard.preferences.county;
    },

  },

  watch: {

    identifyPoint(point) {
      this.$store.dispatch('setPreferences', {
        ...this.$store.state.wizard.preferences,
        coordinates: point,
      });
    },

    step() {
      if (this.$refs.mapComponent.map) {
        this.$refs.mapComponent.invalidateSize();
      }
    },

    loading(value) {
      this.showMessage = value;
    },

  },

  methods: {

    handleAddressSelected(address) {
      console.log(address);
      this.$refs.mapComponent.map.fire('click', {
        latlng: {
          lat: address.location.y,
          lng: address.location.x,
        }
      },);
    },

    nextStep() {
      this.$emit('increment-step');
    },

    handleLocationFound(latlng) {
      console.log('handleLocationFound');
      this.identifyFeatures(latlng);
    },

    handleIdentifyResults({ latlng, results }) {
      let popup;

      const counties = results.map(i => i.properties.County);

      counties.forEach((c) => {
        if (c && this.$store.state.wizard.preferences.county.text !== c) {
          this.$store.dispatch('setPreferences', {
            ...this.preferences,
            county: this.$store.getters.models.county[0],
          });
        }
      });

      const isNotCounty = results.find(i => !i.properties.County);

      if (results.length === 1 && isNotCounty) {
        const msg = 'Regional service outside of communities may be available, and will be presented as an option in results later.';
        popup = new Popup({
          className: 'text-center',
          maxWidth: 100,
        })
          .setLatLng(latlng)
          .setContent(msg)
          .openOn(this.$refs.mapComponent.map);

        setTimeout(() => {
          this.popup.removeFrom(this.$refs.mapComponent.map);
        }, 10000);
      }

      const locationsIdentified = uniq(results.map(i => i.properties.Location));

      const overlap = intersection(
        locationsIdentified,
        this.locationsSelected.map(i => i.text,)
      );

      if (overlap.length) {
        popup = new Popup()
          .setLatLng(latlng)
          .setContent(`Already added: ${overlap.join(',')}`)
          .openOn(this.$refs.mapComponent.map);
      }

      let identifyResults = locationsIdentified.filter(loc => !overlap.includes(loc));

      if (identifyResults.length) {
        const toAdd = [];
        identifyResults.forEach((item) => {
          const result = this.locations.find(loc => loc.text === item);
          if (result) {
            toAdd.push(result);
          }
        });
        this.locationsSelected = [...this.locationsSelected, ...toAdd];

        if (toAdd.length) {
          popup = new Popup()
            .setLatLng(latlng)
            .setContent(`Added: ${toAdd.map(i => i.text).join(',')}`)
            .openOn(this.$refs.mapComponent.map);
        }
      }

      setTimeout(() => {
        if (popup) {
          popup.removeFrom(this.$refs.mapComponent.map);
        }
      }, 10000);

      // this.flagRegionalMessage = false;
      // this.latlng = latlng;
      //
      // const newPoint = point([latlng.lng, latlng.lat]);
      // const fc = featureCollection([newPoint]);
      //
      // const result = tag(fc, featureCollection(this.$store.getters.serviceAreas), 'Location', 'Location');
      //
      // console.warn('result');
      // console.log(result.features[0].properties);
    },

    handleMapLoad() {
      const mapComponent = this.$refs.mapComponent;
      if (mapComponent.map && mapComponent.map) {
        mapComponent.invalidateSize();
      }
    },

    clearCoordinates() {
      this.$store.dispatch('identifyPoint', { latlng: null });
      this.$store.dispatch('clearPreferencesByKey', 'coordinates');
    }

  },

};
</script>
